import script from "./DivideGame.vue?vue&type=script&setup=true&lang=js"
export * from "./DivideGame.vue?vue&type=script&setup=true&lang=js"

import "./DivideGame.vue?vue&type=style&index=0&id=98cadbd4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-98cadbd4"]])

export default __exports__